export default __webpack_public_path__ + "static/media/sale-img.2796c5e1.webp";